export const errorMapping = {
  INSTRUMENT_DECLINED: 'lootPacks:paypalError.instrumentDeclined',
  invalid_request_error: 'lootPacks:stripeError.invalidSource',
  CUSTOMER_EQUALS_TO_GIFTEE_NOT_ALLOWED: 'lootPacks:cantGiftedToYou',
  COUPON_USAGE_LIMIT_REACHED: 'lootPacks:couponUsageLimitReached',
  COUPON_NOT_EXISTS: 'lootPacks:couponNotValid',
  COUPON_NOT_APPLICABLE: 'lootPacks:couponNotApplicable',
};
